import styled, { css } from 'styled-components';
import { NavLink as NavLinkBase } from 'react-router-dom';

export const SideBarContainer = styled.div`
  padding: 16px 8px;
  background: var(--color-interface-neutral-light);
  border-right: 1px solid var(--color-interface-layout-normal);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  justify-items: center;
`;

export const SideBarButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const SideBarLogoContainer = styled.div`
  margin-bottom: 32.23px;
  text-align: center;
`;

export const NavLink = styled(NavLinkBase)`
  --transition-duration: 300ms;
  --size: 40px;

  height: var(--size);
  width: var(--size);
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border: none;
  border-radius: 6px;
  transition: background var(--transition-duration),
    color var(--transition-duration);
  color: var(--color-interface-secondary-normal);
  background: none;

  ${(p) =>
    p.$canBeActiveHack &&
    css`
      &.active {
        color: var(--color-interface-neutral-light);
        background-color: var(--color-interface-secondary-darker);
      }
    `}

  &:focus,
  &:hover {
    background: var(--color-interface-secondary-lighter);
    color: var(--color-interface-neutral-light);
  }

  ${(p) =>
    p.$disabled &&
    css`
      color: var(--color-interface-content-lightest);
      background: none;
      cursor: default;

      &:focus {
        color: var(--color-interface-content-lightest);
        background: none;
      }

      &:hover {
        color: var(--color-interface-content-lighter);
        background: none;
      }
    `}
`;
